import type { PartsListProductsQuery } from '@generated/graphql';
import { nextApiCall } from '@libs/nextApiCall';
import type { PartsListProductFragmentEnhanced } from '@models/enhanced-fragments';

export const fetchPartsListProducts = async (
  ids: string[],
  locale: string,
  priceCountry: string
): Promise<PartsListProductFragmentEnhanced[]> => {
  const response = await nextApiCall('partslist-products', {
    ids,
    locale,
    priceCountry,
  });
  if (!response.ok) {
    throw new Error('unable to fetch products for parts list');
  }

  const result = (await response.json()) as PartsListProductsQuery;
  if (!result.products) {
    throw new Error('Mandatory products attribute missing');
  }

  return result.products as PartsListProductFragmentEnhanced[];
};
